<template>
    <div>
        <content-with-side-menu>
            <template #side-menu>
                <mq-layout mq="tablet+">
                    <inspirations-menu />
                </mq-layout>
            </template>
            <template #main-content>
                <!--<mq-layout mq="mobile"><inspirations-menu /></mq-layout>-->
                <div class="section">
                    <!--<app-search-bar-with-filter
                        v-model="searchText"
                        :filter.sync="filter"
                    />-->
                    <app-search-bar
                        :placeholder="
                            $t('Inspirations.search_placeholder_long')
                        "
                        class=""
                    />
                    <explorer-filter-bar
                        :filters="selectedFolders"
                        @removeFilter="removeSelectedFolder"
                    />
                    <div>
                        <!-- Create new inspiration card -->
                        <div v-if="isAdmin" class="section py-0 px-0">
                            <div class="columns is-multiline is-mobile mx-0">
                                <!--dark card -->
                                <!--<router-link
                                    class="
                                        column
                                        is-12-mobile
                                        is-6-tablet
                                        is-4-desktop
                                        is-3-fullhd
                                        lb-project-card lb-creation-object
                                    "
                                    :to="'/creation'"
                                >
                                    <div
                                        class="
                                            lb-project-box
                                            has-background-prussian-blue
                                        "
                                    >
                                        <div
                                            class="
                                                columns
                                                is-multiline
                                                is-mobile
                                                is-marginless
                                                has-background-prussian-blue
                                            "
                                        >
                                            <div
                                                class="
                                                    column
                                                    is-full
                                                    has-text-centered
                                                    has-text-weight-bold
                                                    has-text-white
                                                "
                                            >
                                                <span class="icon is-large">
                                                    <i
                                                        class="
                                                            mdi
                                                            mdi-10r
                                                            mdi-plus-circle-outline
                                                            pt-5
                                                        "
                                                        aria-hidden="true"
                                                    />
                                                </span>
                                            </div>
                                            <div
                                                class="
                                                    column
                                                    is-full
                                                    has-text-centered
                                                    has-text-weight-bold
                                                "
                                            >
                                                <p
                                                    class="
                                                        is-size-5
                                                        lb-card-title
                                                        is-block
                                                        has-text-white
                                                    "
                                                >
                                                    {{
                                                        $t(
                                                            'Inspirations.add_new_long'
                                                        )
                                                    }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </router-link>
                                -->

                                <!--light card -->
                                <router-link
                                    class="
                                        column
                                        is-12-mobile
                                        is-6-tablet
                                        is-4-desktop
                                        is-3-fullhd
                                        lb-project-card lb-creation-object
                                    "
                                    :to="'/inspirations/new'"
                                >
                                    <div
                                        class="
                                            lb-project-box
                                            has-background-info-light
                                        "
                                    >
                                        <div
                                            class="
                                                columns
                                                is-multiline
                                                is-mobile
                                                is-marginless
                                                has-background-info-light
                                            "
                                        >
                                            <div
                                                class="
                                                    column
                                                    is-full
                                                    has-text-centered
                                                    has-text-weight-bold
                                                    has-text-primary
                                                "
                                            >
                                                <span class="icon is-large">
                                                    <i
                                                        class="
                                                            mdi
                                                            mdi-10r
                                                            mdi-plus-circle-outline
                                                            pt-5
                                                        "
                                                        aria-hidden="true"
                                                    />
                                                </span>
                                            </div>
                                            <div
                                                class="
                                                    column
                                                    is-full
                                                    has-text-centered
                                                    has-text-weight-bold
                                                "
                                            >
                                                <p
                                                    class="
                                                        is-size-5
                                                        lb-card-title
                                                        is-block
                                                        has-text-primary
                                                    "
                                                >
                                                    {{
                                                        $t(
                                                            'Inspirations.add_new_long'
                                                        )
                                                    }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </router-link>
                                <router-link
                                    v-for="inspiration in inspirations"
                                    :key="inspiration._id"
                                    class="
                                        column
                                        is-12-mobile
                                        is-6-tablet
                                        is-4-desktop
                                        is-3-fullhd
                                        lb-project-card lb-creation-object
                                    "
                                    :to="'/inspirations/' + inspiration._id"
                                >
                                    <div class="lb-project-box">
                                        <div
                                            class="
                                                columns
                                                is-multiline
                                                is-mobile
                                                is-marginless
                                                lb-project-background-card
                                            "
                                            :style="cardBackground(inspiration)"
                                        ></div>
                                        <div
                                            class="
                                                columns
                                                is-mobile is-marginless
                                                pt-1
                                            "
                                        >
                                            <div
                                                class="
                                                    column
                                                    is-11
                                                    py-0
                                                    has-text-left
                                                    pt-1
                                                "
                                            >
                                                <p
                                                    class="
                                                        is-size-6
                                                        lb-card-title
                                                        is-block
                                                        has-text-black
                                                    "
                                                >
                                                    {{ inspiration.title }}
                                                </p>
                                            </div>
                                            <div
                                                v-if="isAdmin"
                                                class="column is-1"
                                                @click.stop.prevent=""
                                            >
                                                <div
                                                    class="
                                                        dropdown
                                                        is-right
                                                        is-hoverable
                                                        is-pulled-right
                                                    "
                                                >
                                                    <span
                                                        class="
                                                            icon
                                                            is-small
                                                            dropdown-trigger
                                                            has-text-grey
                                                            mt-1
                                                        "
                                                    >
                                                        <i
                                                            class="
                                                                mdi
                                                                mdi-36px
                                                                mdi-dots-vertical
                                                            "
                                                            aria-hidden="true"
                                                        />
                                                    </span>
                                                    <div
                                                        class="dropdown-menu"
                                                        role="menu"
                                                    >
                                                        <div
                                                            class="
                                                                dropdown-content
                                                            "
                                                        >
                                                            <div
                                                                class="
                                                                    dropdown-item
                                                                "
                                                                @click.stop.prevent="
                                                                    $emit(
                                                                        'delete'
                                                                    )
                                                                "
                                                            >
                                                                <a
                                                                    v-t="
                                                                        'dropdown_option_delete_project'
                                                                    "
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                        </div>

                        <!--<transition-group
                            v-if="loading && !filteredProjects.length"
                            mode="out-in"
                            name="lb-project-list"
                            tag="div"
                            class="columns is-multiline is-mobile mx-0"
                            appear
                        >
                            <div
                                v-for="i in 20"
                                :key="i"
                                class="
                                    column
                                    is-12-mobile is-6-tablet is-4-widescreen
                                "
                            >
                                <div class="lb-project-box is-loading"></div>
                            </div>
                        </transition-group>
                        <projects-grid
                            v-if="filteredProjects.length"
                            :projects="filteredProjects"
                        />
                        <p
                            v-else-if="!loading"
                            v-t="'App.search_empty_results'"
                            class="notification is-info"
                        ></p>-->
                    </div>
                </div>
            </template>
        </content-with-side-menu>
    </div>
</template>

<script>
import InspirationsMenu from '@/components/InspirationsMenu';
//import AppSearchBarWithFilter from '@/components/AppSearchBarWithFilter';
import AppSearchBar from '@/components/AppSearchBar';
import ExplorerFilterBar from '@/components/ExplorerFilterBar';
//import ProjectModalResume from '@/components/ProjectModalResume';
//import ProjectModalShare from '@/components/ProjectModalShare';
import ProjectsGrid from '@/components/ProjectsGrid';
import ContentWithSideMenu from '@/layouts/ContentWithSideMenu';
//import { fetchItems, fetchPublicFolders } from '@/services/API';
import { Document } from 'flexsearch';
import _ from 'underscore';
import { fetchItems } from '@/services/API';
export default {
    components: {
        ExplorerFilterBar,
        InspirationsMenu,
        //AppSearchBarWithFilter,
        AppSearchBar,
        ProjectsGrid,
        // ProjectModalResume,
        // ProjectModalShare,
        ContentWithSideMenu,
    },
    data() {
        return {
            searchText: '',
            folders: [],
            publicProjects: [],
            filter: this.$t('Constants.FILTER_OPTION_PROJECTS_ALL'),
            loading: false,
            filters: [],
            searchIndex: new Document({
                resolution: 3,
                tokenize: 'full',
                document: {
                    id: '_id',
                    index: [
                        'title',
                        'description',
                        'tags',
                        'owner:name',
                        'owner:email',
                    ],
                },
            }),
            showModal: false,
            showShareModal: false,
            project: null,

            inspirations: [],
        };
    },
    computed: {
        filteredFolders() {
            const folders = JSON.parse(JSON.stringify(this.folders));
            switch (this.filter) {
                case this.$t('Constants.FILTER_OPTION_PROJECTS_COLLECTIONS'):
                    return _.map(folders, (folder) => {
                        folder.projects = _.filter(
                            folder.projects,
                            (project) => {
                                return project.type == 'collection';
                            }
                        );
                        return folder;
                    });
                    break;
                case this.$t('Constants.FILTER_OPTION_PROJECTS_GAMES'):
                    return _.map(folders, (folder) => {
                        folder.projects = _.filter(
                            folder.projects,
                            (project) => {
                                return project.type != 'collection';
                            }
                        );
                        return folder;
                    });
                    break;
                default:
                    return this.folders;
                    break;
            }
        },
        filteredProjects() {
            if (this.searchText.length) {
                return this.publicFilteredProjects;
            }
            let folders = this.folders;
            if (this.selectedFolders.length) {
                folders = this.selectedFolders;
            }
            let projects = _.chain(folders).pluck('projects').flatten().value();
            switch (this.filter) {
                case this.$t('Constants.FILTER_OPTION_PROJECTS_COLLECTIONS'):
                    projects = _.filter(projects, (project) => {
                        return project.type == 'collection';
                    });
                    break;
                case this.$t('Constants.FILTER_OPTION_PROJECTS_GAMES'):
                    projects = _.filter(projects, (project) => {
                        return project.type != 'collection';
                    });
                    break;
                case this.$t('Constants.FILTER_OPTION_PROJECTS_ALL'):
                    return projects;
                    break;
                default:
                    return this.publicFilteredProjects;
                    break;
            }
            return projects;
        },
        publicFilteredProjects() {
            this.rebuildIndex();
            this.publicProjects.forEach((item) => {
                this.searchIndex.add(item);
            });
            const result = this.searchIndex.search(this.searchText);
            const ids = _.chain(result).pluck('result').flatten().value();
            return this.publicProjects.filter((item) => {
                return _.contains(ids, item._id);
            });
        },
        type() {
            if (
                this.filter == this.$t('Constants.FILTER_OPTION_PROJECTS_ALL')
            ) {
                return undefined;
            }
            return this.filter ==
                this.$t('Constants.FILTER_OPTION_PROJECTS_COLLECTIONS')
                ? 'collection'
                : 'trivial,treasurehunt';
        },
        selectedFolders() {
            return this.folders.filter((folder) => folder.selected);
        },
        isAdmin() {
            return this.$store.getters.isAdmin;
        },
    },
    watch: {
        searchText: 'searchProjects',
        filter: 'searchProjects',
    },
    mounted() {
        this.fetchInspirations();
    },
    methods: {
        async fetchInspirations() {
            const inspirations = await fetchItems('inspiration');
            this.inspirations = inspirations.data;
        },
        selectProject(project) {
            this.showModal = true;
            this.project = project;
        },
        async searchProjects() {
            this.rebuildIndex();
            this.loading = true;
            let projects = await fetchItems(`project/explore`, {
                title_contains: this.searchText,
                description_contains: this.searchText,
                owner_contains: this.searchText,
                type_in: this.type,
            }).finally(() => {
                this.loading = false;
            });
            this.publicProjects = projects.data;
        },
        rebuildIndex() {
            let folders = this.folders;
            if (this.selectedFolders.length) {
                folders = this.selectedFolders;
            }
            let projects = _.chain(folders).pluck('projects').flatten().value();
            this.searchIndex.remove(projects);
            /*this.searchIndex.destroy();
            this.searchIndex.init({
                document: {
                    id: '_id',
                    index: [
                        'title',
                        'description',
                        'tags',
                        'owner:name',
                        'owner:email',
                    ],
                },
            });*/
        },
        removeSelectedFolder(folder) {
            _.find(this.folders, folder).selected = false;
        },
        cardBackground(inspiration) {
            console.log(inspiration);
            return (
                "background-image: url('" +
                inspiration.image.url +
                "'); background-size: cover; background-repeat: no-repeat; background-position: center center"
            );
        },
    },
};
</script>

<style scooped>
.lb-menu.has-background-pale-grey {
    overflow-y: auto;
}
.lb-creation-object .icon.is-large {
    height: 10rem;
    width: 10rem;
}
.mdi-10r {
    font-size: 10rem;
}
</style>
